export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  date: string;
  author: string;
  tags: string[];
  readTime: number;
  featured: boolean;
}

export const categories = [
  { slug: 'latest', name: '最新动态', icon: 'ri-flashlight-line', description: '友田真希最新消息与活动资讯' },
  { slug: 'works', name: '作品集锦', icon: 'ri-film-line', description: '影视作品、综艺节目与舞台演出' },
  { slug: 'photo', name: '写真集', icon: 'ri-camera-line', description: '精美写真与视觉作品展示' },
  { slug: 'events', name: '艺能活动', icon: 'ri-calendar-event-line', description: '粉丝见面会、签售会与演出日程' },
  { slug: 'interview', name: '深度专访', icon: 'ri-chat-quote-line', description: '媒体采访与独家对话内容' },
  { slug: 'behind', name: '幕后花絮', icon: 'ri-vidicon-line', description: '拍摄现场与未公开的精彩瞬间' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '友田真希 2026 夏季写真集《夏の記憶》正式发布',
    excerpt: '备受期待的友田真希全新夏季写真集《夏の記憶》将于8月下旬正式发售，本次写真集在冲绳取景，收录了超过200张精美写真，展现她在碧海蓝天下的自然魅力。',
    content: `<p>备受期待的友田真希全新夏季写真集《夏の記憶》将于8月下旬正式发售。本次写真集由知名摄影师山田健太郎掌镜，在冲绳美丽的蓝天碧海下取景拍摄。</p>
    <p>写真集收录了超过200张精美写真，分为「晨曦」「正午」「黄昏」「月夜」四个篇章，完整呈现了友田真希在不同时间段、不同场景下的多变魅力。</p>
    <p>友田真希在接受采访时表示："这次的拍摄体验非常特别，冲绳的海风与阳光给了我很多灵感。希望大家能通过这本写真集感受到夏天的温度。"</p>
    <p>《夏の記憶》将于8月25日起在日本全国各大书店及线上平台同步发售，定价3,850日元（含税）。首批预订的粉丝还将获得限量版签名明信片。</p>`,
    category: 'photo',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20elegant%20summer%20beach%20photoshoot%20in%20Okinawa%20with%20flowing%20white%20dress%20under%20blue%20sky%20and%20turquoise%20ocean%2C%20soft%20natural%20lighting%2C%20dreamy%20atmosphere%2C%20professional%20fashion%20photography%20style%2C%20warm%20sunset%20tones%2C%20minimal%20clean%20background%20with%20gentle%20waves&width=1200&height=800&seq=yutamaki-photo-01&orientation=landscape',
    date: '2026-08-10',
    author: '友田真希应援会编辑部',
    tags: ['写真集', '夏季', '冲绳', '新发布'],
    readTime: 8,
    featured: true,
  },
  {
    id: 'article-2',
    title: '友田真希确认出演 NHK 大河剧《平安の光》',
    excerpt: '友田真希正式确认将出演2027年NHK大河剧《平安の光》，饰演平安时代著名女性歌人。这是她首次挑战历史正剧角色，引发广泛关注。',
    content: `<p>NHK于今日正式宣布，友田真希将出演2027年大河剧《平安の光》，在剧中饰演平安时代著名的女性歌人和泉式部。</p>
    <p>这是友田真希首次挑战大河剧角色，也是她演艺生涯中的重大突破。和泉式部是平安时代中期最具代表性的女性歌人之一，其和歌作品至今仍被广泛传颂。</p>
    <p>友田真希在发布会上表示："能够饰演和泉式部这样传奇的历史人物，我感到无比荣幸。我会尽最大努力去理解她的内心世界，为大家呈现一个有血有肉的和泉式部。"</p>
    <p>《平安の光》将于2027年1月起每周日晚播出，全剧预计50集。剧组目前正在京都进行前期筹备工作。</p>`,
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20elegant%20traditional%20Heian%20period%20kimono%20with%20twelve-layer%20juni-hitoe%2C%20standing%20in%20traditional%20Japanese%20garden%20with%20cherry%20blossoms%2C%20soft%20diffused%20lighting%2C%20historical%20drama%20poster%20style%2C%20refined%20and%20graceful%20composition&width=1200&height=800&seq=yutamaki-drama-01&orientation=landscape',
    date: '2026-08-08',
    author: '友田真希应援会编辑部',
    tags: ['NHK', '大河剧', '新剧', '时代剧'],
    readTime: 6,
    featured: true,
  },
  {
    id: 'article-3',
    title: '友田真希 2026 粉丝见面会「真希の部屋」东京站盛况回顾',
    excerpt: '友田真希2026年度粉丝见面会「真希の部屋」东京站于8月5日在东京国际论坛圆满落幕，超过5000名粉丝到场参与，现场气氛热烈。',
    content: `<p>友田真希2026年度粉丝见面会「真希の部屋」东京站于8月5日在东京国际论坛圆满落幕。本次见面会吸引了超过5000名粉丝到场参与。</p>
    <p>见面会分为三个环节：「真希的日常」分享了她近期的生活趣事；「真希的挑战」环节中她即兴表演了钢琴弹唱，让粉丝们惊喜不已；最后的「真希与你」互动环节，她亲自抽取幸运粉丝上台合影。</p>
    <p>友田真希在见面会上感动地说："每次见到大家温暖的笑容，都是让我继续前行的最大动力。""真希の部屋"接下来还将在名古屋和大阪举办，让我们一起期待吧！</p>`,
    category: 'events',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20on%20stage%20at%20fan%20meeting%20event%20waving%20to%20large%20audience%2C%20concert%20hall%20with%20warm%20stage%20lighting%2C%20elegant%20white%20dress%2C%20joyful%20atmosphere%2C%20professional%20event%20photography&width=1200&height=800&seq=yutamaki-event-01&orientation=landscape',
    date: '2026-08-06',
    author: '友田真希应援会编辑部',
    tags: ['粉丝见面会', '东京', 'Live', '真希の部屋'],
    readTime: 5,
    featured: true,
  },
  {
    id: 'article-4',
    title: '专访：友田真希谈演员之路「每一个角色都是一次重生」',
    excerpt: '在本次深度专访中，友田真希回顾了自己从模特转型演员的心路历程，分享了在表演中遇到的挑战与收获，以及她对未来的规划。',
    content: `<p>从时尚杂志的封面模特到如今备受瞩目的实力派演员，友田真希用了十年时间完成了华丽的转身。在本次专访中，她坦诚地分享了自己的心路历程。</p>
    <p>"模特的工作让我学会了如何面对镜头，但演员的工作让我学会了如何面对自己。"友田真希说，"每一个角色都是一次重生，你需要在短时间内完全成为另一个人，这个过程既痛苦又美妙。"</p>
    <p>谈到未来的规划，友田真希表示希望挑战更多不同类型的角色："喜剧、悬疑、甚至动作片，我都想尝试。作为一个演员，我不想被定义。"</p>
    <p>关于保持状态的方法，她分享道："每天坚持阅读和观影是必不可少的，保持对生活的好奇心才能在表演中找到真实的质感。"</p>`,
    category: 'interview',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20elegant%20casual%20outfit%20sitting%20in%20a%20cozy%20modern%20cafe%20for%20interview%20with%20natural%20window%20light%2C%20warm%20and%20intimate%20atmosphere%2C%20soft%20bokeh%20background%2C%20editorial%20photography&width=1200&height=800&seq=yutamaki-interview-01&orientation=landscape',
    date: '2026-08-03',
    author: '友田真希应援会编辑部',
    tags: ['专访', '演员', '心路历程', '深度对话'],
    readTime: 10,
    featured: false,
  },
  {
    id: 'article-5',
    title: '友田真希亮相东京国际电影节红毯，惊艳全场',
    excerpt: '友田真希身着定制礼服亮相第38届东京国际电影节开幕红毯，优雅造型引发媒体与粉丝的热烈讨论。',
    content: `<p>第38届东京国际电影节于8月1日在东京六本木盛大开幕，友田真希身着一袭由日本设计师品牌定制的优雅礼服亮相红毯。</p>
    <p>本次友田真希的造型以"月光"为灵感，银白色的礼服上点缀着手工缝制的珍珠和水晶，在红毯灯光的映照下宛如夜空中的星河。</p>
    <p>友田真希参演的电影《静かなる海》入围了本届电影节的竞赛单元，她在片中饰演一位失去记忆的钢琴家，细腻的表演获得了影评人的一致好评。</p>
    <p>在红毯采访中，友田真希表示能够参与本届电影节是莫大的荣幸，期待与来自世界各地的电影人交流学习。</p>`,
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20on%20red%20carpet%20at%20international%20film%20festival%20wearing%20elegant%20silver%20evening%20gown%20with%20pearl%20details%2C%20glamorous%20lighting%2C%20paparazzi%20flash%20effect%2C%20luxurious%20and%20sophisticated%20atmosphere&width=1200&height=800&seq=yutamaki-redcarpet-01&orientation=landscape',
    date: '2026-08-02',
    author: '友田真希应援会编辑部',
    tags: ['电影节', '红毯', '东京', '造型'],
    readTime: 4,
    featured: false,
  },
  {
    id: 'article-6',
    title: '友田真希新电影《静かなる海》预告片发布，演技获赞',
    excerpt: '由友田真希主演的电影《静かなる海》发布了首支预告片，她在片中饰演失去记忆的钢琴家，精湛的演技引发影迷热议。',
    content: `<p>由友田真希主演、新锐导演田中健吾执导的电影《静かなる海》于今日发布了首支官方预告片。</p>
    <p>电影讲述了一位因事故失去记忆的钢琴家在濑户内海的小岛上重新找回音乐与人生的故事。友田真希在片中零片酬出演，并为此专门学习了六个月的钢琴演奏。</p>
    <p>预告片发布后，友田真希在片中的表演获得了影评人和网友的一致好评。知名影评人山本隆评论道："友田真希的表演有一种难得的真实感，你能从她的眼神中读到角色全部的痛苦与希望。"</p>
    <p>《静かなる海》将于2026年10月在日本全国上映。</p>`,
    category: 'works',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20playing%20piano%20in%20a%20sunlit%20room%20overlooking%20the%20Seto%20Inland%20Sea%2C%20emotional%20expression%2C%20cinematic%20lighting%20with%20soft%20shadows%2C%20film%20still%20aesthetic%2C%20melancholic%20and%20beautiful%20atmosphere&width=1200&height=800&seq=yutamaki-film-01&orientation=landscape',
    date: '2026-07-28',
    author: '友田真希应援会编辑部',
    tags: ['电影', '预告片', '钢琴', '演技'],
    readTime: 5,
    featured: false,
  },
  {
    id: 'article-7',
    title: '幕后揭秘：《夏の記憶》写真集拍摄花絮公开',
    excerpt: '友田真希夏季写真集《夏の記憶》拍摄花絮首度公开，带你走进冲绳的拍摄现场，感受镜头背后的温暖故事。',
    content: `<p>随着友田真希夏季写真集《夏の記憶》发售日临近，官方今日首度公开了一组拍摄花絮照片和视频。</p>
    <p>花絮中可以看到，友田真希在冲绳的拍摄现场非常敬业，即使是在炎热的天气下，她依然保持着专业的态度和充沛的精力。摄影师山田健太郎称赞她"能在瞬间捕捉到最美的表情"。</p>
    <p>特别值得一提的是，花絮中有一幕是友田真希与当地小朋友互动的画面，她亲切地与孩子们一起在海边玩耍，完全没有明星架子。这一幕被摄影师意外捕捉下来，成为了写真集中最温暖的画面之一。</p>`,
    category: 'behind',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20behind%20the%20scenes%20during%20photoshoot%20on%20Okinawa%20beach%2C%20laughing%20naturally%20with%20crew%20members%2C%20casual%20outfit%2C%20golden%20hour%20sunset%20light%2C%20warm%20and%20genuine%20moment%2C%20documentary%20style%20photography&width=1200&height=800&seq=yutamaki-behind-01&orientation=landscape',
    date: '2026-07-25',
    author: '友田真希应援会编辑部',
    tags: ['花絮', '写真集', '冲绳', '幕后'],
    readTime: 4,
    featured: false,
  },
  {
    id: 'article-8',
    title: '友田真希担任「美の祭典2026」形象大使',
    excerpt: '友田真希被任命为「美の祭典2026」形象大使，将在为期一个月的活动中向世界传递日本传统美学与现代美的融合。',
    content: `<p>日本文化厅于今日正式宣布，友田真希将担任「美の祭典2026」的形象大使。该活动是由日本政府主导的国际文化交流项目，旨在向世界展示日本的传统美学与现代创意。</p>
    <p>友田真希将在为期一个月的活动中参与多场文化交流活动，包括传统茶道表演、现代艺术展览以及国际文化交流论坛。</p>
    <p>"能够担任'美の祭典2026'的形象大使，是我莫大的荣耀。"友田真希在记者会上表示，"日本的美，既存在于千年传承的传统之中，也存在于不断创新的现代文化之中。我希望通过这次活动，能让大家感受到这些美的多样性。"</p>`,
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20elegant%20kimono%20at%20cultural%20ceremony%20press%20conference%2C%20holding%20certificate%20of%20appointment%2C%20traditional%20Japanese%20room%20background%20with%20ikebana%20flowers%2C%20dignified%20and%20graceful%20atmosphere%2C%20official%20event%20photography&width=1200&height=800&seq=yutamaki-ambassador-01&orientation=landscape',
    date: '2026-07-20',
    author: '友田真希应援会编辑部',
    tags: ['形象大使', '文化交流', '传统美学', '活动'],
    readTime: 5,
    featured: true,
  },
  {
    id: 'article-9',
    title: '友田真希Instagram粉丝突破500万，暖心发文感谢',
    excerpt: '友田真希个人Instagram账号粉丝数正式突破500万大关，她发布暖心长文感谢粉丝一直以来的支持与陪伴。',
    content: `<p>友田真希个人Instagram账号（@yuta_maki_official）粉丝数于今日正式突破500万大关。</p>
    <p>为庆祝这一时刻，友田真希发布了一篇暖心的长文，回顾了自己从最初开设社交账号到如今的历程。她在文中写道："每一个数字背后都是一份温暖的支持，是你们让我有勇气继续前行。"</p>
    <p>她还特别发布了一段感谢视频，素颜出镜，用最真实的样子与粉丝交流。视频发布仅3小时就获得了超过80万次点赞。</p>
    <p>为了回馈粉丝，友田真希宣布将举办一场线上直播互动活动，届时将与500位幸运粉丝进行一对一视频通话。</p>`,
    category: 'latest',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20taking%20casual%20selfie%20in%20cozy%20home%20setting%2C%20natural%20no-makeup%20look%2C%20warm%20indoor%20lighting%2C%20holding%20phone%20with%20smile%2C%20comfortable%20and%20authentic%20atmosphere%2C%20lifestyle%20photography&width=1200&height=800&seq=yutamaki-social-01&orientation=landscape',
    date: '2026-07-15',
    author: '友田真希应援会编辑部',
    tags: ['Instagram', '500万', '感恩', '粉丝'],
    readTime: 3,
    featured: false,
  },
];

export const profileData = {
  name: '友田真希',
  nameEn: 'Yūta Maki',
  birthdate: '1992年3月15日',
  birthplace: '日本东京都',
  height: '165cm',
  bloodType: 'A型',
  debut: '2010年',
  agency: 'Stardust Promotion',
  hobbies: ['钢琴', '茶道', '旅行', '摄影'],
  specialties: ['日本舞踊', '英语', '料理'],
  socialLinks: {
    instagram: 'https://www.instagram.com/yuta_maki_official',
    twitter: 'https://twitter.com/yuta_maki',
    youtube: 'https://youtube.com/@yutamaki_official',
  },
  biography: `友田真希，1992年3月15日出生于日本东京都。2010年以模特身份出道，凭借独特的气质和出色的表现力迅速成为日本时尚界的宠儿。2013年开始涉足演艺事业，首部参演的电视剧《青春の詩》便获得了广泛关注。

2015年，凭借在电影《桜の季節》中的精彩表现，获得了日本电影学院奖最佳新人奖提名。此后，她陆续出演了多部热门影视作品，包括《星降る夜に》《東京恋物語》《静かなる海》等，演技日益精进。

除了演艺事业，友田真希还积极参与各类公益活动，曾担任联合国儿童基金会日本委员会亲善大使。她热爱传统日本文化，尤其钟爱茶道与日本舞踊，并多次在国际文化交流活动中展示日本传统艺术的魅力。

2026年，友田真希迎来了演艺生涯的新高峰，不仅发布了个人的夏季写真集，还将出演NHK大河剧，事业版图不断扩展。她用十年如一日的努力与真诚，赢得了业界与粉丝的一致认可。`,
  awards: [
    { year: '2015', title: '日本电影学院奖 最佳新人奖提名', work: '《桜の季節》' },
    { year: '2018', title: '日剧学院赏 最佳女配角', work: '《星降る夜に》' },
    { year: '2020', title: '日本电影评论家大奖 最佳女主角', work: '《東京恋物語》' },
    { year: '2023', title: '亚洲电视大奖 最佳女主角提名', work: '《静かなる海》' },
    { year: '2025', title: '日本文化厅艺术选奖 新人奖', work: '综合艺术活动' },
  ],
};